import React from 'react';
import { Icon, IconButton, Tooltip, TextField, InputAdornment } from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import CreateUpdateTaskModal from '../CreateUpdateTaskModal';
import type { TaskDraft } from '../CreateUpdateTaskModal/component';

interface TaskLibraryToolbarProps {
  disabled: boolean;
  onAddAction: (result: boolean) => void;
  onSearchAction: (name: string) => void;
}

// Create mode: no id is what tells the modal it is adding a task, and it clears the fields on open.
const emptyTask: TaskDraft = {};

const TaskLibraryToolbar: React.FC<TaskLibraryToolbarProps> = (props) => {
  const { disabled, onAddAction, onSearchAction } = props;

  const { t } = useTranslation();

  const [name, setName] = React.useState<string>('');
  const [taskModalOpened, setTaskModalOpened] = React.useState(false);

  const handleOnCreateTask = (result: boolean) => {
    setName('');
    setTaskModalOpened(false);
    onAddAction && onAddAction(result);
  };

  return (
    <>
      <div className="mb-3 flex items-center justify-between gap-2">
        <h3 className="m-0 text-sm font-semibold text-slate-900">{t('f-tasks-manager-tasks-library')}</h3>
        <Tooltip title={t('f-add')}>
          <span>
            <IconButton
              size="small"
              aria-label={t('f-add')}
              onClick={() => setTaskModalOpened(true)}
              disabled={disabled}
            >
              <Icon>add</Icon>
            </IconButton>
          </span>
        </Tooltip>
      </div>
      <TextField
        label={t('f-tasks-manager-search')}
        size="small"
        fullWidth
        variant="outlined"
        value={name}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon className="text-slate-400 !text-lg/none">search</Icon>
            </InputAdornment>
          )
        }}
        onChange={(e) => {
          setName(e.target.value);
          onSearchAction(e.target.value);
        }}
      />

      <CreateUpdateTaskModal
        key="add-new"
        opened={taskModalOpened}
        task={emptyTask}
        onModalAction={handleOnCreateTask}
      />
    </>
  );
};

export default TaskLibraryToolbar;
